<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>地区管理</h4>
        </div>
        <div class="main-hd">
            <el-row class="searchSection">
                <el-form ref="searchModel" :inline="true" :model="searchModel">
                    <el-form-item label="关键词" prop="keyword">
                        <el-input type="text" v-model="searchModel.keyword" auto-complete="off"
                                  placeholder="地区名称/简称/拼音"></el-input>
                    </el-form-item>
                    <el-form-item label="地区等级" prop="level">
                        <el-select v-model="searchModel.level">
                            <el-option label="省" value="1"></el-option>
                            <el-option label="市" value="2"></el-option>
                            <el-option label="区/县" value="3"></el-option>
                            <el-option label="乡/镇" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <DistrictLinkage ref="DistrictLinkage" @change="handleDistrictChange($event)"
                                     :trigger-on-change="true"></DistrictLinkage>
                    <el-form-item label="显示类型" prop="level">
                        <el-select v-model="searchModel.display">
                            <el-option label="全部" value="0"></el-option>
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="已删除" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitSearch" size="small">搜索</el-button>
                        <el-button size="small" @click="resetSearch">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
        </div>

        <div class="main-bd mg15">

            <el-row>
                <el-button type="primary" @click="dialogFormVisible = true" size="small">新增地区</el-button>
            </el-row>

            <el-alert
                    title="温馨提示：此处的地区管理仅作为功能性地区，不会与主站的行政地区同步"
                    type="success"
                    :closable="false">
            </el-alert>

            <el-table border :data="districts" style="width: 100%;margin-top: 5px;" v-loading="loading">
                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                <el-table-column prop="name" label="地区名称"></el-table-column>
                <el-table-column prop="level_name" label="地区级别" width="100"></el-table-column>
                <el-table-column prop="shortname" label="简称" width="80"></el-table-column>
                <el-table-column prop="pinyin" label="拼音"></el-table-column>
                <el-table-column prop="state_label" label="状态" width="80"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleUpdate(scope.row)" type="primary" size="small" plain>编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="danger" size="small" plain>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>

            <el-dialog :title="getDialogTitle()" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="地区名称" label-width="120px">
                        <el-input v-model="form.name" autocomplete="off"></el-input>
                    </el-form-item>
                    <DistrictLinkage 
                        ref="DistrictLinkage" 
                        @change="handleDistrictChange2($event)"
                        :trigger-on-change="true" item-label-width="120px" 
                        :provinceId="parseInt(form.province_id)"
                        :cityId="parseInt(form.city_id)"
                        :districtId="parseInt(form.district_id)" 
                        :key="districtLinkageKey">
                    </DistrictLinkage>
                    <el-form-item label="地区等级" label-width="120px">
                        <el-select v-model="form.level" placeholder="请选择地区等级">
                            <el-option label="省" value="1"></el-option>
                            <el-option label="市" value="2"></el-option>
                            <el-option label="区/县" value="3"></el-option>
                            <el-option label="乡/镇" value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="地区简称" label-width="120px">
                        <el-input v-model="form.shortname" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="closeDialog">取 消</el-button>
                    <el-button type="primary" @click="saveForm" :loading="loading">确 定</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import DistrictService from "~/services/district";
    import Pagination from "~/widgets/Pagination.vue";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";

    export default {
        name: "index",
        components: {
            Pagination,
            DistrictLinkage
        },
        data() {
            return {
                searchModel: {
                    keyword: '',
                    upid: '',
                    level: '',
                    page: '',
                    perPage: '',
                    display: '',
                },
                form: {
                    id: '',
                    name: '',
                    shortname: '',
                    pinyin: '',
                    upid: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                },
                districts: [],
                loading: false,
                linkPage: null,
                dialogFormVisible: false,
                districtLinkageKey: 0
            };
        },
        created() {
            this.getList();
        },
        methods: {

            getList(params = {}) {
                this.loading = true;
                DistrictService.getList(params).then(res => {
                    if (res && res.code == 0) {
                        this.districts = res.data;
                    }

                    if (res._meta) {
                        this.linkPage = res._meta;
                    }

                    this.loading = false;
                })
            },

            handleUpdate(district) {
                if (district.level) {
                    district.level = district.level + '';
                }
                this.form = district;
                if(district.level == 2){
                    this.form.province_id = district.upid;
                    this.form.city_id = 0;
                    this.form.district_id = 0;
                    this.districtLinkageKey ++;
                }else if(district.level == 3){
                    this.form.city_id = district.upid;
                    this.form.district_id = 0;
                    DistrictService.getInfo(district.upid).then(res => {
                        if (res && res.code == 0) {
                            this.form.province_id = res.data.upid;
                        }
                        this.districtLinkageKey ++;
                    })
                }else if(district.level == 4){
                    this.form.district_id = district.upid;
                    DistrictService.getInfo(district.upid).then(res => {
                        if (res && res.code == 0) {
                            this.form.city_id = res.data.upid;
                            DistrictService.getInfo(res.data.upid).then(res2 => {
                                if (res2 && res2.code == 0) {
                                    this.form.province_id = res2.data.upid;
                                }
                                this.districtLinkageKey ++;
                            })
                        }
                    })
                }
                this.dialogFormVisible = true;
            },

            handleDelete(district) {

                let text = '';
                if (district.is_deleted == 0) {
                    text = '确定要删除地区 ' + district.name + ' 吗?';
                } else {
                    text = '当前地区已经处于删除状态,继续该操作将会被彻底删除，确定继续吗？';
                }

                this.$confirm(text, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    DistrictService.delete(district.id).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }

                        this.getList(this.searchModel);
                    })
                }).catch(() => {
                    return;
                });
            },

            submitSearch() {
                this.getList(this.searchModel);
            },

            resetSearch() {
                this.searchModel = {
                    keyword: '',
                    upid: '',
                    level: '',
                    page: '',
                    perPage: ''
                };
                this.getList();
            },

            // 监听分页切换回调
            watchPageChange(pageParams) {
                this.searchModel.page = pageParams["page"];
                this.searchModel.perPage = pageParams["perPage"];
                this.getList(this.searchModel);
            },

            handleDistrictChange(value) {
                if (value.length && value.length > 0) {
                    let upid;
                    value.forEach((districtId, index) => {
                        if (districtId > 0) {
                            upid = districtId;
                        }
                    })

                    this.searchModel.upid = upid;
                }
            },

            handleDistrictChange2(value) {
                if (value.length && value.length > 0) {
                    let upid;
                    value.forEach((districtId, index) => {
                        if (districtId > 0) {
                            upid = districtId;
                        }
                    })

                    this.form.upid = upid;
                }
            },

            getDialogTitle() {
                return this.form.id > 0 ? '编辑地区' : '新增地区';
            },

            closeDialog() {
                this.form = {
                    id: '',
                    name: '',
                    shortname: '',
                    pinyin: '',
                    upid: '',
                };

                this.dialogFormVisible = false;
            },

            saveForm() {
                this.loading = true;
                if (this.form.id > 0) {
                    DistrictService.update(this.form).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: "保存成功!",
                                type: "success",
                                showClose: true,
                            });
                        }
                        this.loading = false;
                        this.getList(this.searchModel);

                        this.closeDialog();
                    }).catch(() => {
                        this.loading = false;
                    });
                } else {
                    DistrictService.create(this.form).then(res => {
                        if (res && res.code == 0) {
                            this.$message({
                                message: "保存成功!",
                                type: "success",
                                showClose: true,
                            });
                        }
                        this.loading = false;
                        this.getList(this.searchModel);
                        this.closeDialog();
                    }).catch(() => {
                        this.loading = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/district/index.vue